const initState = {
};

const survey = (state = initState, action) => {
    switch (action.type) {
        case 'INIT_SURVEY':
            return {
                ...state,
                ...action.json
            };
        default:
            return state
    }
};

export default survey;


// WEBPACK FOOTER //
// ./sources/js/reducers/surveyReducer.js